var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnglish = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 18,
  fill: "none",
  viewBox: "0 0 630 480"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#english_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#english_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M345 0h530v480H345z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m407.109 0 202.063 181L810.406 0H875v62L676.25 241 875 419v61h-66.25L610 301 412.078 480H345v-60l197.922-178L345 64V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M696.125 281 875 440v40L650.578 281zM543.75 301l4.969 35-159 144H345zM875 0v3L668.797 191l1.656-44L833.594 0zM345 0l197.922 176h-49.688L345 42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M544.578 0v480h132.5V0zM345 160v160h530V160z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M345 193v96h530v-96zM571.078 0v480h79.5V0z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#english_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BD3D44",
  d: "M-320 0h640v480h-640"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M-320 55.3h640Zm0 73.7h640Zm0 74h640Zm0 74h640Zm0 74h640Zm0 74h640Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 37,
  d: "M-320 55.3h640M-320 129h640m-640 74h640m-640 74h640m-640 74h640m-640 74h640"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#192F5D",
  d: "M-320 0H44.8v258.5H-320"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "english_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h630v480H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "english_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M345 0h530v480H345z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "english_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-320 0h640v480h-640z"
})))));
export { SvgEnglish as ReactComponent };
export default __webpack_public_path__ + "assets/images/english.6bd1973f47dc40591b32a837729cde9e.svg";